import { render, staticRenderFns } from "./VersionStatus.vue?vue&type=template&id=e4c1dd0c&"
import script from "./VersionStatus.vue?vue&type=script&lang=ts&"
export * from "./VersionStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports